<template>
  <div class="formGroup isRequired mt15">
    <label class="label toCapitalize notranslate">{{locale.reservation_place}}</label>
    <SeatMap
      :locale="locale"
      :lang="lang"
      :seats="seats"
      :objects="seatMap.seatObj"
      :info="seatMap.info"
      :count="seatCount"
      :activeTarget="activeTarget"
      @activeSeat="activeSeat" />
  </div>
</template>

<script>
import SeatMap from '@/components/Reservation/SeatMap'

export default {
  name: 'ReservationFormSeat',
  props: [
    'lang',
    'ln',
    'locale',
    'info',
    'roomKey',
    'rid',
    'isPublic',
    'placeId',
    'seatMap',
    'seatCount',
    'remainSeat'
  ],
  components: {
    SeatMap
  },
  computed: {
    activeTarget () {
      return this.seat && this.seat.map(x => x.seatId)
    },
    seats () {
      const seats = this.seatMap.seats
      const remain = this.remainSeat
      const placeId = this.placeId

      return seats.map(x => {
        const isOtherPlace = x.placeId !== placeId

        const isRemain = remain &&
          remain[x.placeId] &&
          remain[x.placeId].remainSeats &&
          remain[x.placeId].remainSeats.includes(x.seatId)

        return {
          ...x,
          disabled: x.disabled || isOtherPlace || !isRemain
        }
      })
    }
  },
  watch: {
    seatCount () {
      this.seat = []
    }
  },
  data () {
    return {
      seat: []
    }
  },
  methods: {
    activeSeat (data) {
      const count = this.seatCount
      const length = this.seat.length

      function toggle (arr, data) {
        return arr.find(x => x.seatId === data.seatId)
          ? arr.filter(x => x.seatId !== data.seatId)
          : [...arr, data]
      }

      if (count > 1) {
        if (count > length) {
          this.seat = toggle(this.seat, data)
        } else if (
          count === length &&
          this.seat.find(x => x.seatId === data.seatId)
        ) {
          this.seat = toggle(this.seat, data)
        }
      } else if (count === 1) {
        this.seat = [data]
      }

      this.$emit('setSeatMap', this.seat)
    }
  }
}
</script>
